import { useContext } from 'react';
import Select from 'react-select';
import useMemoAsync from 'src/hooks/useMemoAsync';
import { getModelService } from 'src/services/ModelService';
import { getVectorStoreService } from 'src/services/VectorStoreService';
import { capitalize, copyToClipboard } from 'src/utils';
import { AiAgentActions, AiAgentContext } from './AgentDetailPageComponent';
import { AiAgent } from 'src/types/AiAgent';
import { AppAgentContext } from 'src/context/ContextProvider';
import { mdiContentCopy } from '@mdi/js';
import Icon from '@mdi/react';

export const AgentSettingsComponent = () => {

    const { state: { ai_agent }, dispatch } = useContext(AiAgentContext);
    const { state: { session } } = useContext(AppAgentContext);

    const modelOptions = useMemoAsync(async () => {
        const res = await getModelService();
        if (res.success) {
            return res.items.map(item => ({
                value: item,
                label: capitalize(item),
            }));
        }
        return [];
    }, [], []);

    const vectorOptions = useMemoAsync(async () => {
        const res = await getVectorStoreService();
        if (res.success) {
            return res.items.map(item => ({
                value: item,
                label: item === 'Pinecone' ? 'VectorStore  Database' : capitalize(item),
            }));
        }
        return [];
    }, [], []);

    return (
        <div className="flex gap-5 p-5">
            <div className="w-full">
                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Nombre del Proyecto</label>
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={ai_agent.name}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none"
                        placeholder="Escribe el nombre de tu proyecto"
                        onChange={(event) => {
                            const regex = /^[a-z0-9]*$/; // Permite texto vacío o alfanumérico
                            if (regex.test(event.target.value)) {
                                const agent = new AiAgent(ai_agent);
                                agent.setName(event.target.value);
                                dispatch(AiAgentActions.setAiAgent(agent));
                                // dispatch(AiAgentActions.setAgent({...Agent, name: event.target.value}))
                            }
                        }}
                    />
                </div>
                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Modelo</label>
                    <Select
                        value={ai_agent.getSelectModel()}
                        options={modelOptions}
                        onChange={(option) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setSelectModel(option);
                            dispatch(AiAgentActions.setAiAgent(agent));
                        }}
                        placeholder={'Select your Model'}
                    />
                </div>
                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Vector Store</label>
                    <Select
                        value={ai_agent.getSelectVectorStore()}
                        options={vectorOptions}
                        onChange={(option) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setSelectVectorStore(option);
                            dispatch(AiAgentActions.setAiAgent(agent));
                            // dispatch(AiAgentActions.setAgent({...Agent, vectorStore: option || {value: '', label: ''}}))
                        }}
                        placeholder={'Select your Vector'}
                    />
                </div>
                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Contexto</label>
                    <textarea
                        rows={4}
                        autoComplete={'off'}
                        value={ai_agent.context}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                        placeholder="Escribe tu contexto"
                        onChange={(event) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setContext(event.target.value);
                            dispatch(AiAgentActions.setAiAgent(agent));
                            // dispatch(AiAgentActions.setAgent({...Agent, context: event.target.value}))
                        }}
                    />
                </div>
                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Contexto del historial de chat</label>
                    <textarea
                        rows={4}
                        autoComplete={'off'}
                        value={ai_agent.chat_history_context}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                        placeholder="Escribe tu contexto del historial de chat"
                        onChange={(event) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setChatHistoryContext(event.target.value);
                            dispatch(AiAgentActions.setAiAgent(agent));
                        }}
                    />
                </div>

                <div className="relative grid gap-1 items-center mb-5">
                    <label htmlFor="">Script</label>
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={`${session.origin}/www/${session.domainName}/ai-agent/scripts/${ai_agent.name}.js`}
                        readOnly
                        className="py-2 pl-4 pr-9 w-full rounded border border-gray-400 outline-none"
                    />
                    <div
                        onClick={() => copyToClipboard(`${session.origin}/www/${session.domainName}/ai-agent/scripts/${ai_agent.name}.js`)}
                        className="absolute bg-white right-1 top-1/2 cursor-pointer">
                        <Icon path={mdiContentCopy} size={1} />
                    </div>
                </div>

                <div className="relative grid gap-1 items-center mb-5">
                    <label htmlFor="">Privacy and policy url</label>
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={`${session.origin}/www/${session.domainName}/ai-agent/scripts/${ai_agent.name}.js`}
                        readOnly
                        className="py-2 pl-4 pr-9 w-full rounded border border-gray-400 outline-none"
                    />
                    <div
                        onClick={() => copyToClipboard(`${session.origin}/www/${session.domainName}/ai-agent/scripts/${ai_agent.name}.js`)}
                        className="absolute bg-white right-1 top-1/2 cursor-pointer">
                        <Icon path={mdiContentCopy} size={1} />
                    </div>
                </div>
            </div>
        </div>
    );
};
